import React from "react";
import { expertTalk } from "..";

function ExpertTalk() {
  return (
    <section className="expertTalkSection">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="talkLeftBox">
              <img src={expertTalk} alt="" className="img-fluid rounded-4" />
            </div>
          </div>
          <div className="col-md-4 offset-1">
            <div className="talkRightBox">
              <h5>
                “The Vodote team helped us transition from legacy systems to a hardened infrastructure. Their attention to risk, user safety, and compliance made a measurable impact on our operations.”
              </h5>
              <h6>Lina Patel</h6>
              <span>CISO</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExpertTalk;
